export default __webpack_public_path__ + "static/media/sushi.abd129af.svg";